<app-navbar title="Historia">
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<app-history type="tourist_guides" [id]="id"></app-history>
